// removed by extract-text-webpack-plugin
module.exports = {"OffersCard":"OffersCard__MhU4g","offerImage":"offerImage__dKWc_","offerContent":"offerContent__3wTMe","merchantName":"merchantName__2UheK","offerText":"offerText__1_IMN"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/offersCard/style.css
// module id = Z5Pc
// module chunks = 323